import { Icon, ModBox, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import { ButtonNew } from '../AdminButton'
import React from 'react'
import { Clipboard } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'

interface props {
  item: any
}
const TerminalListItem = ({ item }: props) => {
  const { getQrUrlOfTerminal, generateQrUrl, mid, createVpaOnChangeJioPartner } = useStores((store) => ({
    getQrUrlOfTerminal: store.onboarding.getQrUrlOfTerminal,
    generateQrUrl: store.onboarding.generateNewQrUrl,
    mid: store.onboarding.mid,
    createVpaOnChangeJioPartner: store.onboarding.createVpaOnChangeJioPartner,
  }))

  const [fetchQrUrl] = useLazyApiData(generateQrUrl)

  const vpa = item?.vpaQrUrl?.split(',')[0]
  const qrUrl = item?.vpaQrUrl?.split(',')[1] //getQrUrlOfTerminal(item?.terminalID)

  const handleOnGenerateQrUrl = () => {
    const merchantData = {
      merchantId: mid,
      type: 'STATIC',
      qrInterfaceType: 'UPI',
      // medium: 'PRINT',
      // gstIn: '27AAAAA0000A1Z5',
      // intentId: merchantData.intentId,
      // notification:
      //   mid === 'NP'
      //     ? undefined
      //     : {
      //         sms: [`+91${item?.mobile}`],
      //       },
      paymentAcceptance: mid === 'NP' ? undefined : ['526'],
      vpa: vpa ? vpa : undefined,
    }
    fetchQrUrl(merchantData)
  }
  const handleOnCopyClipboard = () => {
    if (qrUrl && qrUrl.length > 0) {
      Clipboard.setString(qrUrl)
    }
  }
  const handleChangeToJioPay = () => {
    let merchantData = { mid: mid, terminalId: item?.terminalID, vpa: vpa }
    createVpaOnChangeJioPartner(merchantData)
  }

  return (
    <ModBox marginLeft={32}>
      <ModBox
        h={40}
        backgroundColor={vpa?.toLowerCase()?.includes('jiopartner') ? 'WHITE' : '#F7F7F7'}
        borderWidth={1}
        borderRadius={4}
        borderColor={'BORDER_COLOR'}
        w={'100%'}
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        paddingLeft={16}
        underlayColor={'TRANSPARENT'}>
        <Text
          title={vpa ?? ''}
          textAlign={'left'}
          fontFamily={'jiotype-medium'}
          fontSize={12}
          color={'BLACK_21'}
          opacity={!vpa?.toLowerCase()?.includes('jiopartner') ? 100 : 70}
        />
        <ModBox
          direction="row"
          show={vpa?.toLowerCase()?.includes('jiopartner')}
          borderLeftWidth={1}
          borderLeftColor={'BORDER_COLOR'}>
          <ButtonNew
            borderColor={'TRANSPARENT'}
            height={32}
            type={'secondary'}
            title={"Change VPA to '@JioPay'"}
            hoverColor={'TRANSPARENT'}
            underlayColor={'TRANSPARENT'}
            onPress={handleChangeToJioPay}
          />
        </ModBox>
      </ModBox>
      <ModBox
        show={!vpa?.toLowerCase()?.includes('jiopartner')}
        direction="row"
        w={'100%'}
        marginTop={8}
        borderWidth={1}
        borderRadius={4}
        borderColor={'BORDER_COLOR'}>
        <ModBox borderRightWidth={1} borderRightColor={'BORDER_COLOR'}>
          <ButtonNew
            borderColor={'TRANSPARENT'}
            height={32}
            type={'secondary'}
            title={'Generate URL'}
            hoverColor={'TRANSPARENT'}
            underlayColor={'TRANSPARENT'}
            onPress={handleOnGenerateQrUrl}
          />
        </ModBox>
        <ModBox>
          <TextInputNew
            {...styles.textinput}
            value={qrUrl}
            placeholder={'QR URL will be generated here...'}
            editable={false}
          />
        </ModBox>
        <ModBox
          w={37}
          show={qrUrl?.length > 0}
          borderLeftWidth={1}
          borderLeftColor={'BORDER_COLOR'}
          onPress={handleOnCopyClipboard}
          alignItems={'center'}
          justifyContent={'center'}
          underlayColor={'GRAY_BORDER'}>
          <Icon color="PRIMARY" size={16} id="DUPLICATE" />
        </ModBox>
      </ModBox>
    </ModBox>
  )
}
const styles = {
  textinput: {
    textWidth: 511,
    borderColor: 'TRANSPARENT',
    height: 32,
    type: 'body12',
    labelPaddingBottom: 8,
    labelFontFamily: 'jiotype-bold',
    fontFamily: 'jiotype-medium',
    labelColor: 'BRAND_COLOR_GRAY_1',
    labelFontSize: 12,
    fontSize: 12,
    paddingHorizontal: 8,
    focusBorderColor: 'TRANSPARENT',
  } as TextInputNewProps,
}
export { TerminalListItem }
